// CreateSettlementReqFFormMDP


import * as Action from "@/../src-gen/action";
import FSnackbar from "@/fsnackbar";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormDrawerMDP, { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";


export default class CreateSettlementReqFFormMDP extends FFormDrawerMDP {
    childMDP = new FFormChildMDP();
    parent: any;

    constructor({ parent, isVisible, onClose }: { parent: any; isVisible: boolean; onClose: () => void }) {


        super({ myRefName: "CreateSettlementReqFFormRef", isVisible: isVisible, onClose: onClose })

        this.parent = parent;

        this.addField(
            new FPhoneFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "creditorMobile",
                label: "Agent Mobile",
                boundaryClass: "col-6",
                mandatory: true
            })
        ).addField(
            new FTextFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "creditorName",
                label: "Agent Name",
                boundaryClass: "col-6",
            })
        ).addField(
            new FTextFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "bankAgencyName",
                label: "Bank/Agency Name",
                boundaryClass: "col-6",
            })
        ).addField(
            new FTextareaMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "comment",
                label: "comment",
                boundaryClass: "col-6",
            })
        )
            .addAction(new FFormSubmitBtnMDP({
                label: "Create Settlement Request",
                onClick: () => this.parent.createSettlementRequest()
            }))

    }

    getMyRef(): any {
        return this.parent.$refs[this.myRefName];
    }

   


}